import $ from 'jquery';
import Swal from 'sweetalert2';
import { submitSubscribesForm, callSubscribesForm } from './subcribesForm';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    participating: 'Você está participando',
    swal_success: 'Sucesso!',
    swal_sucess_text: 'Inscrição concluída com sucesso!',
    are_you_sure: 'Você tem certeza que quer deixar de participar desta ação?',
    no: 'NÃO TENHO',
    yes: 'SIM, TENHO',
  },
  en: {
    participating: 'You are participating',
    swal_success: 'Success!',
    swal_sucess_text: 'Registration completed successfully!',
    are_you_sure: 'Are you sure you want to leave this action?',
    no: 'No, I’m not',
    yes: 'Yes, I am',
  },
  es: {
    participating: 'Estas participando',
    swal_success: '¡Éxito!',
    swal_sucess_text: '¡Registro completado exitosamente!',
    are_you_sure: '¿Estás seguro de que quieres dejar de participar en esta acción?',
    no: 'NO TENGO',
    yes: 'SI TENGO',
  },
};

export const userSubscribe = () => {
  // Faz a inscrição
  function subscription(challengeId) {
    $.ajax({
      type: 'POST',
      url: '/efetuar-inscricao/',
      data: {
        challenge_id: challengeId,
        _token: $('meta[name="csrf-token"]').attr('content'),
      },
      dataType: 'json',
      success: function (data) {
        if (data.type === 'success') {
          Swal.fire(tr[lang].swal_success, tr[lang].swal_success_text, 'success').then(function () {
            window.location.reload();
          });
        } else {
          Swal.fire(data.title, data.message, data.type);
        }
      },
    });
  }

  // Envia a função de inscrição do usuário para a função de submit do formulário
  submitSubscribesForm(subscription);

  // Evento do botão de participar
  $(document).on('click', '[data-type="participate"]', function (e) {
    e.preventDefault();
    let challengeId = $(this).attr('data-challenge'),
      isForm = $(this).is('[data-form]');

    if (isForm) {
      callSubscribesForm(challengeId);
    } else {
      subscription(challengeId);
    }
  });

  // Evento do botão de desparticipar
  $(document).on('click', '[data-type="disparticipate"]', function (e) {
    e.preventDefault();

    Swal.fire({
      title: tr[lang].are_you_sure,
      showCancelButton: true,
      confirmButtonColor: '#0402bf',
      cancelButtonColor: '#fff',
      cancelButtonText: tr[lang].no,
      confirmButtonText: tr[lang].yes,
      padding: '50px',
      reverseButtons: true,
      customClass: 'c-new-swal',
    }).then(result => {
      if (result.value) {
        let challengeId = $(this).attr('data-challenge');

        $.ajax({
          type: 'POST',
          url: '/cancelar-inscricao/',
          data: {
            challenge_id: challengeId,
            _token: $('meta[name="csrf-token"]').attr('content'),
          },
          dataType: 'json',
          success: function (data) {
            if (data.type === 'success') {
              window.location.reload();
            } else {
              Swal.fire(data.title, data.message, data.type);
            }
          },
        });
      }
    });
  });
};
